import { environment } from "../environments/environment.development";
import { ListItem } from "../models/ListItem";
import { ApplicationUser, UpdateUserProfile } from "../models/user.model";
import GenericService from "./genericService";
import { httpService } from "./httpService";

class UserService extends GenericService<ApplicationUser, ListItem> {
  constructor() {
    super("/api/User");
  }

  async getUsersByRole(roleName: string): Promise<ApplicationUser[]> {
    return await httpService.get<ApplicationUser[]>(
      `${environment.baseURL}/User/GetUsersByRole/${roleName}`,
      undefined,
      {
        unwrap: true,
        normalize: true,
        toast: false,
      }
    );
  }

  async getCurrentUserDetails(): Promise<ApplicationUser> {
    return await httpService.get<ApplicationUser>(
      `${environment.baseURL}/api/User/GetCurrentUserDetails`,
      undefined,
      {
        unwrap: true,
        normalize: false,
        toast: false,
      }
    );
  }

  async getCurrentUsersFromApi(): Promise<ApplicationUser[]> {
    return await httpService.get<ApplicationUser[]>(
      `/api/User/SearchRMCUsers`,
      undefined,
      {
        unwrap: true,
        normalize: true,
        toast: false,
      }
    );
  }
  async updateUserProfile(data: UpdateUserProfile): Promise<boolean> {
    await httpService.put<any>(`/api/User/UpdateUserProfile`, data, undefined, {
      unwrap: true,
      normalize: false,
      toast: true,
    });
    return true;
  }
}

export const userService = new UserService();
